import { InputProps } from 'antd/lib/input';
import React from 'react';
import ModalFooter from '@components/sources/source/ModalFooter';
import DynamicInput from '@ui-library/dynamicInput';
import { FixMe } from '@utils/types';
import { MappingState } from '../../tableMappingProvider';
import { Header, SubHeader } from '../../../style';

interface EditColumnModalProps extends InputProps {
  defaultValue: string;
  mappingState: MappingState;
  viewOnly: boolean;
}

const EditColumnModal = ({ defaultValue, mappingState, viewOnly }: EditColumnModalProps) => {
  const {
    setRenamedRows,
    renamedRows,
    deleteFromRenamedRow,
    setSelectedRow,
    selectedColumns,
    overridesConfig,
    validateName,
  } = mappingState;
  const renameList = renamedRows[defaultValue] || [];
  const [rowsToMap, setMappedRows] = React.useState<string[]>(
    (renameList && [...renameList]) || [],
  );
  const onSubmit = React.useCallback((val: string[]) => {
    setRenamedRows({ [defaultValue]: val });
  }, []);

  const handlePopUpOk = React.useCallback(
    async (e?: React.MouseEvent<HTMLElement, MouseEvent>) => {
      e?.stopPropagation();
      if (rowsToMap) {
        await onSubmit(rowsToMap);
      }
      const mappedRowsToDelete = renameList.filter((n) => !rowsToMap.includes(n));
      if (mappedRowsToDelete && mappedRowsToDelete.length > 0) {
        await deleteFromRenamedRow({
          [defaultValue]: renameList.filter((n) => !rowsToMap.includes(n)),
        });
      }

      if (
        (!rowsToMap || rowsToMap.length === 0) &&
        selectedColumns.includes(defaultValue) &&
        overridesConfig?.user_id !== defaultValue &&
        overridesConfig?.anonymous_id !== defaultValue
      ) {
        setSelectedRow(defaultValue);
      }
    },
    [rowsToMap, renameList],
  );
  return (
    <div>
      <div style={{ margin: '4px' }}>
        <Header>Manage trait keys</Header>
        <SubHeader>Add or remove as many trait keys as you'd like</SubHeader>
      </div>
      <DynamicInput
        editMode={!viewOnly}
        values={rowsToMap}
        onChange={setMappedRows}
        validateInput={(value: FixMe) => validateName(value, defaultValue, rowsToMap)}
      />
      <ModalFooter onConfirm={handlePopUpOk} />
    </div>
  );
};

export default EditColumnModal;
